import React, { useState, useRef, useEffect } from 'react'
import { Table } from 'react-bootstrap';
import { BsArrowDown, BsArrowUp } from 'react-icons/bs';
import './CommonCheckboxTable.css'
import CheckboxComponent from '../CheckBox/index';
import { useSelector } from 'react-redux';
import { RootState } from '@store/reducers';

interface columnheaderType {
  name: string;
  key: string;
  sortable: boolean;
  width?: number;
  showDetails?: string
  gridView?: boolean
}

interface DataTableProps {
  data: any[];
  height?: string;
  columnHeader: columnheaderType[];
  gridFor: string;
  handleCheckboxChange: (changedData:any, moduleName:any, privilegeIndex:any, tableName: string) => void ;
  }
const CommonCheckboxTable = (props: DataTableProps) => {
  const { data, height = '100%', columnHeader, gridFor, handleCheckboxChange } = props;
  const [sortKey, setSortKey] = useState<string>('');
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc');
  const [tableData, setTableData] = useState<any[]>([]);
  const isEditable = useSelector((state: RootState) => state.user.edit_privilege_flow);

  const tableRef1 = useRef(null);
  
  const currentItems = data
  .sort((a, b) => {
    if (a && b && sortKey && sortOrder) {
      const aSortKey = a[sortKey] && a[sortKey].type === "component" ? a[sortKey].value : a[sortKey];
      const bSortKey = b[sortKey] && b[sortKey].type === "component" ? b[sortKey].value : b[sortKey];
        if (sortOrder === 'asc') {
          if (!aSortKey || aSortKey === null || aSortKey === '') return 1;
          if (!bSortKey || bSortKey === null || bSortKey === '') return -1;
          return aSortKey.localeCompare(bSortKey);
        } else if (sortOrder === 'desc') {
          if (!aSortKey || aSortKey === null || aSortKey === '') return -1;
          if (!bSortKey || bSortKey === null || bSortKey === '') return 1;
          return bSortKey.localeCompare(aSortKey);
        } else {
          return 0;
        }
      } else {
        return 0;
      }
    })

    useEffect(() => {
      setTableData(currentItems);
    },[data]);

  const handleSort = (key: string) => {
    if (sortKey === key) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortKey(key);
      setSortOrder('asc');
    }
  };
  const getSortIndicator = (key: string) => {
    if (sortKey === key) {
      return sortOrder === 'asc' ? <BsArrowUp /> : <BsArrowDown />;
    }
    return null;
  };


return (
  <>
    {tableData && tableData.length > 0 ? (
      <div className="datatable-container" style={{ height: height }}>
        <Table className="table-cl" responsive ref={tableRef1}>
          <thead>
            <tr>
              {columnHeader?.map((header, index) => (
                <th
                  key={index}
                  onClick={() => header.sortable && handleSort(header.key)}
                  className={`header ${header.name}`}
                  style={{
                    cursor: 'pointer',
                    width: header.width ? `${header.width}px` : 'auto',
                    display: header.gridView ? 'none' : '',
                    textAlign: index === columnHeader?.length-1 ? "center" : 'start',
                  }}
                >
                  {header.name}
                  {getSortIndicator(header.key) && (
                    <span>{getSortIndicator(header.key)}</span>
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableData &&
              tableData.map((item, index) => (
                <tr key={index}>
                  <td style={{minWidth: "266px"}}>{item?.title}</td>
                  <td className="privelege-table-data">
                    {item.privileges.map((privilege: any, idx: any) => (
                      <label key={idx} className={'table-checkbox'}>
                        <div key='privilege' className={'privilege_wrapper'}>
                          <CheckboxComponent
                            className={!isEditable ? 'cursor-not-allowed' : ''}
                            placeCheckboxBefore={false}
                            isChecked={privilege.enabled}
                            checkBoxName={privilege.name}
                            disabled={false}
                            onCheckboxChange={(changedData) => {
                              handleCheckboxChange(changedData, item.title, idx, item.module_code);
                            }}
                          />
                        </div>
                      </label>
                    ))}
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
    ) : (
      <div className="datatable-container">{'No Records Found'}</div>
    )}
  </>
);
};
export default CommonCheckboxTable;
